import React from "react";
import "./Navbar.css";

const Navbar = () => {
  return (
    <div className="navbar">
      {/* <a href="#aboutme">ABOUT ME</a> */}
      <a href="#home">HOME</a>
      <a href="#skills">SKILLS</a>
      <a href="#project">PROJECT</a>
      <a href="#contact">CONTACT</a>

    </div>
  );
};

export default Navbar;
